
// cores da paleta de design
const palleteColor1 = "#163B9A"
const palleteColor2 = "#F6A935"

export {
  palleteColor1,
  palleteColor2
};
